import { createContext, use } from "react";
import type { ImageAnnotatorController } from "./use-image-annotator";

interface IImageAnnotatorContext {
	controller: ImageAnnotatorController;
}

export const ImageAnnotatorContext = createContext<IImageAnnotatorContext>(
	{} as IImageAnnotatorContext,
);

export function useImageAnnotatorContext(): IImageAnnotatorContext & {
	scale: number;
	baseScale: number;
} {
	const context = use(ImageAnnotatorContext);
	return {
		...context,
		scale: context.controller.scale || 1,
		baseScale: context.controller.baseScale || 1,
	};
}
